import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import NotificationsList from '../components/notifications/NotificationsList';
import { NOTIFICATION_QUICK_FILTER_IDS } from '../constants/notificationsQuickFilters';
import './NotificationsPage.css';

function NotificationsPage({ isActive = false, onNavigateTab = null }) {
  const { t } = useTranslation('notifications');
  const [quickFilter, setQuickFilter] = useState('all');
  const [refreshTick, setRefreshTick] = useState(0);

  const handleRefresh = () => {
    setRefreshTick((prev) => prev + 1);
  };

  return (
    <div className="notifications-page">
      <div className="page-container">
        <header className="page-header">
          <div className="page-header-content">
            <div>
              <h1>{t('notifications.title')}</h1>
              <p className="page-subtitle">{t('notifications.subtitle')}</p>
            </div>
            <button
              type="button"
              className="notifications-refresh-btn"
              onClick={handleRefresh}
              title="Odśwież powiadomienia"
              aria-label="Odśwież powiadomienia"
            >
              <span aria-hidden="true">↻</span>
            </button>
          </div>
          <div
            className="notifications-quick-filters"
            role="toolbar"
            aria-label={t('notifications.quick_filters.aria')}
          >
            {NOTIFICATION_QUICK_FILTER_IDS.map((id) => (
              <button
                key={id}
                type="button"
                className={`notifications-quick-filter${quickFilter === id ? ' is-active' : ''}`}
                onClick={() => setQuickFilter(id)}
                aria-pressed={quickFilter === id}
              >
                {t(`notifications.quick_filters.${id}`)}
              </button>
            ))}
          </div>
        </header>

        <main className="notifications-content">
          <NotificationsList
            key={refreshTick}
            isActive={isActive}
            onNavigateTab={onNavigateTab}
            quickFilterId={quickFilter}
            onClearQuickFilter={() => setQuickFilter('all')}
          />
        </main>
      </div>
    </div>
  );
}

export default NotificationsPage;
